import { render, staticRenderFns } from "./veStuHealthAskAdmin.vue?vue&type=template&id=adb91dd8&scoped=true"
import script from "./veStuHealthAskAdmin.vue?vue&type=script&lang=js"
export * from "./veStuHealthAskAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb91dd8",
  null
  
)

export default component.exports